import { render, staticRenderFns } from "./x-facets.component.vue?vue&type=template&id=5313dce8&scoped=true"
import script from "./x-facets.component.vue?vue&type=script&lang=ts"
export * from "./x-facets.component.vue?vue&type=script&lang=ts"
import style0 from "./x-facets.component.vue?vue&type=style&index=0&id=5313dce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5313dce8",
  null
  
)

export default component.exports